import React, {Component} from 'react';
import { Container,Carousel,Button,Row,Col, } from 'react-bootstrap';
import $ from 'jquery'
import Footer from './Footer'
import Fixed from './Fixed'
import './all.css'
import img1 from '../img/pg_banner.png'
import syrq from '../img/syrq.png'
import fwms from '../img/fwms.png'
import nlcl from '../img/nlcl.png'
import jmsm from '../img/jmsm.png'
import jkyj from '../img/jkyj.png'
import jkms from '../img/jkms.png'
import fyyf from '../img/fyyf.png'
import dhjfxf from '../img/dhjfxf.png'
import pfjs from '../img/pfjs.png'
import hxjfgz from '../img/hxjfgz.png'
import xyxh from '../img/xyxh.png'
import shwstt from '../img/shwstt.png'
import bhst from '../img/bhst.png'
import shjrst from '../img/shjrst.png'
import jhmyxt from '../img/jhmyxt.png'
import jkglfw from '../img/jkglfw.png'
import weektc from '../img/weektc.png'
import mouthtc from '../img/mouthtc.png'
import bntc from '../img/bntc.png'
import yeartc from '../img/yeartc.png'
import gmlc from '../img/gmlc.png'
import zysx from '../img/zysx.png'
import './all.css'


class Healthy extends Component {
    constructor(props) {
        super(props)
        this.state = {}
    }

    
    handleEnter = el=>{
        $('.'+el).css({'display':'block'})
    }
    handleOut = el=>{
        $('.'+el).css({'display':'none'})
    }
    render() {
        return (
            <div>
                <Row className='margin0'>
                    <img className="d-block w-100" src={img1} />
                </Row>
                <Row className="justify-content-md-center">
                    <Col xs="auto" lg={8}>
                        <img className="d-block w-100" src={syrq} style={{marginTop:'3%'}}/>
                    </Col>
                </Row>
                <Row className="justify-content-md-center">
                    <Col xs="auto" lg={8}>
                        <img className="d-block w-100" src={fwms} style={{marginTop:'3%'}}/>
                    </Col>
                </Row>
                <Row>
                    <Col className='textCenter'>
                        <h4 style={{marginTop:'3%'}}>经脉评估服务</h4>
                        <div style={{margin:'2% 0'}}>Meridians assessment service</div>
                    </Col>
                </Row>
                <Row className="justify-content-md-center">
                    <Col lg={2}>
                        <div className='rftl_item' onMouseEnter={()=>this.handleEnter('hover1')} onMouseLeave={()=>this.handleOut('hover1')}>
                            <img src={nlcl} className="d-block w-100"/>
                            <div className='rftl_item_title textCenter'>经脉总能量测量</div>
                            <div className='rftl_item_msg'>测量各条经脉皮肤的电参数来量化经脉总体活力</div>
                            <div className='rftl_item_hover display_none hover1'>
                                <div className='rftl_item_hover_msg center'>测量各条经脉皮肤的电参数来量化经脉总体活力</div>
                                <div className='rftl_item_title_hover center'>经脉总能量测量</div>
                            </div>
                        </div>
                    </Col>
                    <Col lg={2}>
                        <div className='rftl_item' onMouseEnter={()=>this.handleEnter('hover2')} onMouseLeave={()=>this.handleOut('hover2')}>
                            <img src={nlcl} className="d-block w-100"/>
                            <div className='rftl_item_title textCenter'>经脉总失衡度测量</div>
                            <div className='rftl_item_msg'>检测经脉系统的宏观有序状态从多角度考量经脉系统总体平衡状态</div>
                            <div className='rftl_item_hover display_none hover2'>
                                <div className='rftl_item_hover_msg center'>检测经脉系统的宏观有序状态从多角度考量经脉系统总体平衡状态</div>
                                <div className='rftl_item_title_hover center'>经脉总失衡度测量</div>
                            </div>
                        </div>
                    </Col>
                    <Col  lg={2}>
                        <div className='rftl_item' onMouseEnter={()=>this.handleEnter('hover3')} onMouseLeave={()=>this.handleOut('hover3')}>
                            <img src={jkms} className="d-block w-100"/>
                            <div className='rftl_item_title textCenter'>经脉健康综述</div>
                            <div className='rftl_item_msg'>从经脉活力以及平衡角度给予用户身体健康的总结</div>
                            <div className='rftl_item_hover display_none hover3'>
                                <div className='rftl_item_hover_msg center'>从经脉活力以及平衡角度给予用户身体健康的总结</div>
                                <div className='rftl_item_title_hover center'>经脉健康综述</div>
                            </div>
                        </div>
                    </Col>
                    <Col lg={2}>
                        <div className='rftl_item' onMouseEnter={()=>this.handleEnter('hover4')} onMouseLeave={()=>this.handleOut('hover4')}>
                            <img src={jmsm} className="d-block w-100"/>
                            <div className='rftl_item_title textCenter'>调理经脉说明</div>
                            <div className='rftl_item_msg'>可根据24经脉测量结果给出异常经脉，以及关系到的身体系统和疾病相关说明</div>
                            <div className='rftl_item_hover display_none hover4'>
                                <div className='rftl_item_hover_msg center'>可根据24经脉测量结果给出异常经脉，以及关系到的身体系统和疾病相关说明</div>
                                <div className='rftl_item_title_hover center'>调理经脉说明</div>
                            </div>
                        </div>
                    </Col>
                    <Col lg={2}>
                        <div className='rftl_item' onMouseEnter={()=>this.handleEnter('hover5')} onMouseLeave={()=>this.handleOut('hover5')}>
                            <img src={jkyj} className="d-block w-100"/>
                            <div className='rftl_item_title textCenter'>健康预警</div>
                            <div className='rftl_item_msg'>检查你的异常经脉异常数据，有效预警疾病发生并，在短时间内通知您以及家人</div>
                            <div className='rftl_item_hover display_none hover5'>
                                <div className='rftl_item_hover_msg center'>检查你的异常经脉异常数据，有效预警疾病发生并，在短时间内通知您以及家人</div>
                                <div className='rftl_item_title_hover center'>健康预警</div>
                            </div>
                        </div>
                    </Col>
                </Row>
                <Row className="justify-content-md-center">
                    <Col xs="auto" >
                        <img className="d-block w-100" src={jkglfw} style={{marginTop:'3%'}}/>
                    </Col>
                </Row>
                <Row>
                    <Col className='textCenter'>
                        <h4 style={{marginTop:'3%'}}>服务参考价格</h4>
                        <div style={{margin:'2% 0'}}>Health management services</div>
                    </Col>
                </Row>
                <Row className="justify-content-md-center">
                    <Col lg={2}>
                        <div className='rftl_item'>
                            <img src={weektc} className="d-block w-100"/>
                        </div>
                    </Col>
                    <Col lg={2}>
                        <div className='rftl_item'>
                            <img src={mouthtc} className="d-block w-100"/>
                        </div>
                    </Col>
                    <Col  lg={2}>
                        <div className='rftl_item'>
                            <img src={bntc} className="d-block w-100"/>
                        </div>
                    </Col>
                    <Col lg={2}>
                        <div className='rftl_item'>
                            <img src={yeartc} className="d-block w-100"/>
                        </div>
                    </Col>
                </Row>
                <Row className="justify-content-md-center">
                    <Col xs="auto" lg={8}>
                        <img className="d-block w-100" src={gmlc} style={{marginTop:'3%'}}/>
                    </Col>
                </Row>
                <Row>
                    <Col className='textCenter'>
                        <h4 style={{marginTop:'3%'}}>注意事项</h4>
                        <div style={{margin:'2% 0'}}>Matters needing attention</div>
                    </Col>
                </Row>
                <Row className="justify-content-md-center">
                    <Col xs="auto" lg={3}>
                        <img className="d-block w-100" src={zysx}/>
                    </Col>
                    <Col xs="auto" lg={5} style={{fontSize:12,lineHeight:'25px'}}>
                        <div>1、服务周期为周、月、半年者另需租赁押金: 聆枢测量笔￥3000；经疏干预棒￥5000。</div>
                        <div>2、用户使用周、月、半年服务套餐期满后，应及时归还，否则按实际归还时间计算扣除超出部分费用，押金扣完后服 务合同终结。</div>
                        <div>3、用户使用任何服务满一年后，如继续使用套餐，可在年套餐服务上打8折，并赠送1500积分。</div>
                        <div>4、当用户连续使用年套餐服务满三年，第四年继续使用时，设备可享受一次以旧换新活动。</div>
                        <div>5、当用户丢失服务套餐中的设备后如需继续使用服务须补交检测笔费用2100元，干预棒费用5600元，系统将禁用丢 失的设备。</div>
                        <div>6、用户如果中途想升级套餐时，费用为升级套餐的费用-旧套餐累计花费的费用=需补交的钱数，服务有效期为1年- 旧套餐累计已用的时间=可用的有效期 </div>
                        <div>7、所有服务项目有效期均为一年</div>
                    </Col>
                </Row>
                <Footer/>
                <Fixed/>
            </div>
        )
    }
}

export default Healthy;

